(() => {
  // ---------------------------------------------------------------------
  // 1) Ensure Shopify.formatMoney is defined (same code you had inline)
  // ---------------------------------------------------------------------
  if (!Shopify.formatMoney) {
    Shopify.money_format = null;
    Shopify.formatMoney = cents =>
      Shopify.money_format.replace('', (cents/100).toFixed(2));
  }

  // ---------------------------------------------------------------------
  // 2) Star-rendering helper (same as before)
  // ---------------------------------------------------------------------
  function renderStars(el, rating) {
    const STAR_SVG = `Liquid error: This liquid context does not allow includes.`;
    el.innerHTML   = `${STAR_SVG}<span>${rating.toFixed(1)}</span>`;
  }

  // ---------------------------------------------------------------------
  // 3) Main cross-sell logic
  // ---------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', () => {
    // Find all product-page (and cart-page) cross-sells on the current page
    document.querySelectorAll('.cross-sell-section').forEach(async (wrapper) => {
      const carouselId = wrapper.dataset.carouselId;
      const seedId     = wrapper.dataset.seedId;
      const details    = wrapper.querySelector('details.accordion__disclosure');
      const summary    = wrapper.querySelector('summary');
      const carousel   = wrapper.querySelector(`#${carouselId}`);
      const tpl        = document.getElementById(`${carouselId}-template`);
      const prevBtn    = wrapper.querySelector(`#${carouselId}-prev`);
      const nextBtn    = wrapper.querySelector(`#${carouselId}-next`);
      if (!details || !summary || !carousel || !tpl) return;

      // disable manual accordion-click until we auto-open
      let readyToOpen = false;
      summary.style.pointerEvents = 'none';
      summary.addEventListener('click', e => {
        if (!readyToOpen) e.preventDefault();
      }, true);

      // 3.1) Fetch cart
      let cart = { items: [], item_count: 0, items_subtotal_price: 0 };
      try {
        cart = await fetch('/cart.js').then(r => r.json());
      } catch (e) { console.warn('[Product] cart.js failed', e); }
      const inCart = cart.items.map(i => i.variant_id);

      // 3.2) Fetch recommendations
      let recs = [];
      const params = new URLSearchParams();
      params.set('type', 'product-page');
      params.set('shopify_product_ids', seedId);
      if (inCart.length) {
        params.set('shopify_variant_ids', inCart.join(','));
      }
      
      if (cart.items_subtotal_price != null) {
        params.set('cart_subtotal', cart.items_subtotal_price);
      }
      if (cart.item_count != null) {
        params.set('cart_item_count', cart.item_count);
      }
      if (cart.items.length) {
        params.set('cart_line_count', cart.items.length);
      }
      params.set('metafields', 'yes');
      params.set('variant_metafields', 'true');
      params.set('format', 'pretty');
      params.set('limit', '10');
      params.set('time', new Date().toISOString());
      params.set('uuid', crypto.randomUUID ? crypto.randomUUID() : `uuid-${Date.now()}`);
      params.set('url', window.location.pathname);
      const cc = (navigator.language || '').split('-')[1];
      if (cc) params.set('country_code', cc);
      try {
        await new Promise(r => setTimeout(r, 500));
        console.log('[Product]', `https://api.sowandarrow.com/recommendations?${params}`);
        const res  = await fetch(`https://api.sowandarrow.com/recommendations?${params}`, {
          method:      'GET',
          mode:        'cors',
          credentials: 'include',
        });
        const json = await res.json();
        recs = (json.recommendations || json.data || []).slice(0, 10);
      } catch (e) { /* silently ignore */ }

      recs = recs.filter(r => !inCart.includes(r.variants[0].id));
      if (!recs.length) { wrapper.style.display = 'none'; return; }

      // 3.3) Auto-open after a brief delay
      setTimeout(() => {
        readyToOpen = true;
        summary.style.pointerEvents = '';
        details.open = true;
        summary.click();
      }, 500);

      // 3.4) Render each card
      carousel.innerHTML = '';
      for (const rec of recs) {
        const frag = document.createRange().createContextualFragment(tpl.innerHTML);
        const card = frag.firstElementChild;
        card.classList.add('active');
        // link, image, title
        const linkEl = card.querySelector('a[data-instant]');
        const imgEl  = card.querySelector('img');
        const title  = card.querySelector('a.subheading');
        linkEl.href = rec.link;
        imgEl.src   = rec.image.src;
        imgEl.alt   = rec.image.alt;
        title.href  = rec.link;
        title.textContent = rec.title;

        // price & stars
        const priceEl  = card.querySelector('.product-cross-sell__price');
        const ratingEl = card.querySelector('[data-loox-rating]');
        const cents    = Math.round(parseFloat(rec.variants[0].price) * 100);
        priceEl.textContent = Shopify.formatMoney(cents);
        const rawRating = rec.metafields?.loox?.avg_rating;
        const rating    = rawRating != null ? parseFloat(rawRating) : NaN;
        if (!isNaN(rating) && rating > 0) renderStars(ratingEl, rating);
        else ratingEl.remove();

        // stock/options/add-to-cart form
        const v0        = rec.variants[0];
        let inStock     = v0.available ?? true;
        let needsOptions = rec.variants.length > 1;
        if (!needsOptions) {
          try {
            const pd = await fetch(`${rec.link.replace(/\/$/,'')}.js`).then(r => r.json());
            needsOptions = Array.isArray(pd.selling_plan_groups) && pd.selling_plan_groups.length;
          } catch {}
        }
        const placeholder = card.querySelector('button');
        const modal      = card.querySelector('quick-buy-modal');
        const qbId       = `${carouselId}-qb-${rec.id}`;

        if (!inStock) {
          // sold out button
          const f = document.createElement('form');
          f.className = 'product-cross-sell__form';
          const b = document.createElement('button');
          b.type = 'submit'; b.disabled = true;
          b.className = 'link subheading subheading-xs';
          b.textContent = "Sold out";
          f.append(b); placeholder.replaceWith(f);
          modal && modal.remove();

        } else if (needsOptions) {
          // choose options
          const f = document.createElement('form');
          f.className = 'product-cross-sell__form';
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'link subheading subheading-xs';
          b.textContent = "Choose options";
          b.setAttribute('aria-controls', qbId);
          f.append(b); placeholder.replaceWith(f);
          if (modal) { modal.id = qbId; modal.setAttribute('product-url', rec.link); }

        } else {
          // add to cart
          const f = document.createElement('form');
          f.className = 'product-cross-sell__form';
          f.method    = 'post';
          f.action    = '/cart/add.js';
          f.addEventListener('submit', async e => {
            e.preventDefault();
            try {
              const cart = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({ id: v0.id, quantity: 1 })
              }).then(r => r.json());
              document.dispatchEvent(new CustomEvent('variant:add',   { bubbles: true, detail: { items: [{ id: v0.id, quantity: 1 }], cart } }));
              document.dispatchEvent(new CustomEvent('cart:change',  { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.querySelector('a[href="/cart"],[data-drawer-toggle="cart"],.js-drawer-open-cart')?.click();
            } catch (err) { console.error('[Product] add-to-cart failed', err); }
          });
          const inp = document.createElement('input');
          inp.type = 'hidden'; inp.name = 'id'; inp.value = v0.id;
          f.append(inp);
          const sb = document.createElement('button');
          sb.type = 'submit';
          sb.className = 'link subheading subheading-xs';
          sb.textContent = "Add to cart";
          f.append(sb);
          placeholder.replaceWith(f);
          modal && modal.remove();
        }

        carousel.appendChild(card);
      }

      // 3.5) Prev/Next arrow logic
      function updateArrows() {
        const max = carousel.scrollWidth - carousel.clientWidth;
        prevBtn.classList.toggle('at-start', carousel.scrollLeft <= 0);
        nextBtn.classList.toggle('at-end',   carousel.scrollLeft >= max);
      }
      updateArrows();
      prevBtn.addEventListener('click', e => {
        e.stopPropagation();
        if (!prevBtn.classList.contains('at-start')) {
          carousel.scrollBy({ left: -carousel.clientWidth, behavior: 'smooth' });
        }
      });
      nextBtn.addEventListener('click', e => {
        e.stopPropagation();
        if (!nextBtn.classList.contains('at-end')) {
          carousel.scrollBy({ left: carousel.clientWidth, behavior: 'smooth' });
        }
      });
      carousel.addEventListener('scroll', updateArrows);
    });
  });
})();